<!-- 已迁移 -->
<template>
    <div class="layout-wrap">
        <commonContent>
            <template #routerView>
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive" />
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive" />
            </template>
        </commonContent>
    </div>
</template>

<script>
import commonHeader from '@/layout/components/Header';
import commonContent from '@/layout/components/Content';

export default {
    components: {
        commonHeader,
        commonContent
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {}
};
</script>

<style lang="less" scoped>
.layout-wrap {
    width: 100%;
    height: 100%;
}
</style>
